// extracted by mini-css-extract-plugin
export default {"headingContainer":"FormHeading_headingContainer__Pjhoh","heading":"FormHeading_heading__EHIsh","subHeading":"FormHeading_subHeading__rFFUZ"};